import { clamp, finiteVec } from '../game/math'
import type { Vec2 } from '../game/types'

export interface MobileDriveInput {
  steer: number
  throttle: number
  brake: number
}

export const NEUTRAL_DRIVE: MobileDriveInput = { steer: 0, throttle: 0, brake: 0 }

const DEAD_ZONE = 0.12

export function mapJoystick(offset: Vec2, radius: number): MobileDriveInput {
  if (!finiteVec(offset) || !Number.isFinite(radius) || radius <= 0) return NEUTRAL_DRIVE
  const rawMagnitude = Math.hypot(offset.x, offset.y)
  const magnitude = Math.min(radius, rawMagnitude)
  const normalized = magnitude / radius
  if (normalized <= DEAD_ZONE || rawMagnitude === 0) return NEUTRAL_DRIVE

  const strength = (normalized - DEAD_ZONE) / (1 - DEAD_ZONE)
  const direction = { x: offset.x / rawMagnitude, y: offset.y / rawMagnitude }
  return {
    steer: clamp(-direction.x * strength, -1, 1),
    throttle: clamp(-direction.y * strength, 0, 1),
    brake: clamp(direction.y * strength, 0, 1),
  }
}
